module.exports = __webpack_public_path__ + "fonts/KaTeX_Caligraphic-Bold.de2ba279.woff";